import { OneApi } from '../../components/one-api/one-api';
import { createQueryEndpoint } from '../requests/helpers';
import { setCurrentLanguage } from './env.slice';

export const EnvEndpoints = {
  loadCurrentLanguage: createQueryEndpoint<void, string>('env.loadCurrentLanguage', {
    queryFn: (_args, { dispatch }) => {
      const currentLanguage = OneApi.userAPI.getCurrentLanguage();
      dispatch(setCurrentLanguage({ lang: currentLanguage }));
      return { data: currentLanguage };
    },
  }),
};
